<template>
  <div>
    <b-row>
      <b-col md="3">
        <b-form-group label="Search Phone Number">
          <UsersSearch
            v-if="searchBy == 'users'"
            @users-selection="onUserSelection"
          />
          <DriversSearch
            v-else
            @drivers-selection="onUserSelection"
          />
        </b-form-group>
      </b-col>
      <b-col
        md="9"
        class="d-flex justify-content-end align-items-center"
      >
        <b-button
          variant="primary"
          :disabled="!selectedUsers.length"
          @click="exportFile"
        >
          Submit
        </b-button>
      </b-col>
    </b-row>
    <hot-table
      ref="handsontable"
      :settings="hotSettings"
    />
  </div>
</template>

<script>
import {
  BFormGroup, BButton, BRow, BCol,
} from 'bootstrap-vue'
import { HotTable } from '@handsontable/vue'
import { registerAllModules } from 'handsontable/registry'
import { ref, watch } from '@vue/composition-api'
import useRegisterStoreModule from '@/hooks/useRegisterStoreModule'
import transactionTypesStore from '../../transaction-types/transactionTypesStore'
import UsersSearch from '@/views/users/rider/components/UsersSearch.vue'
import DriversSearch from '@/views/driver/components/DriversSearch.vue'
import { errorNotification } from '@/utils/toast-notifications'

export default {
  components: {
    HotTable,
    UsersSearch,
    DriversSearch,
    BFormGroup,
    BButton,
    BRow,
    BCol,
  },
  props: {
    searchBy: {
      type: String,
      required: true,
    },
  },
  setup(props, ctx) {
    useRegisterStoreModule('transaction-types', transactionTypesStore)
    registerAllModules()
    const selectedUsers = ref([])
    const onUserSelection = user => {
      selectedUsers.value.push(user)
    }
    const transactionTypes = ref([])
    const fetchTransactionTypes = async () => {
      const res = await ctx.root.$store.dispatch('transaction-types/fetchTransactionTypes')
      transactionTypes.value = res.map(el => el.slug)
    }
    fetchTransactionTypes()
    const handsontable = ref(null)
    const hotSettings = {
      minRows: 0,
      data: [],
      colHeaders: ['Phone Number', 'Id', 'Amount', 'Remark Text', 'Transaction Type'],
      colWidths: [150, 270, 100, 250, 310],
      licenseKey: 'non-commercial-and-evaluation',
      contextMenu: ['remove_row'],
      allowEmpty: false,
      columns: [
        {
          readOnly: true,
        },
        {
          readOnly: true,
        },
        {
          type: 'numeric',
        },
        {
          validator: (val, cb) => cb(!!val),
        },
        {
          type: 'autocomplete',
          source(_, process) {
            process(transactionTypes.value)
          },
          strict: true,
        },
      ],
      afterRemoveRow: ix => {
        selectedUsers.value.splice(ix, 1)
      },
    }

    const exportFile = () => {
      handsontable.value.hotInstance.validateCells(val => {
        console.log(val)
        if (val) {
          let currentData = handsontable.value.hotInstance.getData()
          currentData = currentData.map(row => {
            // remove phone number from row data
            row.shift()
            return row
          })
          handsontable.value.hotInstance.updateSettings({
            data: currentData,
            colHeaders: ['external_id', 'amount', 'remark_text', 'transaction_type_slug'],
            colWidths: [150, 100, 250, 350],
            columns: [
              {
                readOnly: true,
              },
              {
                type: 'numeric',
              },
              {},
              {
                type: 'autocomplete',
                source(query, process) {
                  process(transactionTypes.value)
                },
                strict: true,
              },
            ],
          })
          const exportPlugin = handsontable.value.hotInstance.getPlugin('exportFile')
          const exportedBlob = exportPlugin.exportAsBlob('csv', {
            bom: false,
            columnDelimiter: ',',
            columnHeaders: true,
            rowDelimiter: '\r\n',
          })
          ctx.emit('file-ready', exportedBlob)
        } else {
          errorNotification('Validation Failed..')
        }
      })
    }
    watch(selectedUsers, val => {
      const usersLength = val.length
      handsontable.value.hotInstance.setDataAtCell(usersLength - 1, 0, val[usersLength - 1].phoneNumber)
      handsontable.value.hotInstance.setDataAtCell(usersLength - 1, 1, val[usersLength - 1].id)
    })
    return {
      handsontable,
      hotSettings,
      onUserSelection,
      selectedUsers,
      exportFile,
    }
  },
}
</script>

<style>

</style>
